export enum LocalStorageKeys {
  Cookie = 'accept-cookies',
  ConfirmEmailNDB = 'confirm-email-ndb-modal',
}

export class LocalStorage<T, U> {
  key: string;
  defaultValue: U;

  constructor(key: string, emptyValue: U) {
    this.key = key;
    this.defaultValue = emptyValue;
  }

  get() {
    const item = localStorage.getItem(this.key);
    try {
      if (item == null) return this.defaultValue;
      return JSON.parse(item) as T;
    } catch {
      return (item as any as T) || this.defaultValue;
    }
  }

  push(object: T) {
    const oldObject = this.get();

    if (Array.isArray(oldObject) && Array.isArray(object)) {
      this.replace([...oldObject, ...object] as any as T);
    } else if (Array.isArray(oldObject) && typeof object === 'object') {
      this.replace([...oldObject, object] as any as T);
    } else if (oldObject != null && typeof oldObject === 'object') {
      this.replace({ ...oldObject, ...object } as any as T);
    } else {
      this.replace(object);
    }
  }

  replace(object: T) {
    const json = JSON.stringify(object);
    localStorage.setItem(this.key, json);
  }

  remove() {
    localStorage.removeItem(this.key);
  }
}
